(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CV_rising-brand"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rising-brand')) {
    class RisingBrand extends HTMLElement {
      connectedCallback() {
        // 담기(+) 버튼은 이벤트 위임: 자식 요소가 아직 파싱되기 전에 호출되어도 항상 동작
        if (!this.__rbDelegated) {
          this.__rbDelegated = true;
          this.addEventListener('click', (e) => {
            const btn = e.target && e.target.closest ? e.target.closest('[data-rb-add]') : null;
            if (btn && this.contains(btn)) { e.preventDefault(); this.quickAdd(btn); }
          });
        }
        // 스크립트가 head에서 먼저 실행되면 이 시점엔 자식 DOM이 비어 있을 수 있으므로 파싱 완료 후 초기화
        const start = () => { if (this.__rbInit) return; this.__rbInit = true; this.init(); };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
        else start();
      }

      init() {
        this.tabs = Array.from(this.querySelectorAll('[data-rb-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-rb-panel]'));
        this.live = this.querySelector('[data-rb-live]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, false));
          tab.addEventListener('keydown', (e) => this.onTabKey(e, i));
        });
        this.panels.forEach((p) => this.initPanel(p));

      }

      select(index, focus) {
        this.tabs.forEach((t, i) => {
          const on = i === index;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (this.panels[i]) this.panels[i].hidden = !on;
        });
        if (focus) this.tabs[index].focus();
        this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'center' });
        this.querySelectorAll('cj-brand-video video').forEach((video) => video.pause());
        const track = this.panels[index] && this.panels[index].querySelector('[data-rb-track]');
        if (track) track.dispatchEvent(new Event('scroll'));
      }

      onTabKey(e, i) {
        const n = this.tabs.length;
        let next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % n;
        else if (e.key === 'ArrowLeft') next = (i - 1 + n) % n;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = n - 1;
        if (next !== null) { e.preventDefault(); this.select(next, true); }
      }

      initPanel(panel) {
        const track = panel.querySelector('[data-rb-track]');
        const nav = panel.querySelector('[data-rb-nav]');
        const prev = panel.querySelector('[data-rb-prev]');
        const next = panel.querySelector('[data-rb-next]');
        const update = () => {
          if (!track) return;
          const max = track.scrollWidth - track.clientWidth;
          // 내용이 넘치지 않으면(상품 4개 이하 등) 스크롤 UI 숨김
          if (nav && !panel.hidden) nav.hidden = max <= 2;
          if (prev) prev.disabled = track.scrollLeft <= 1;
          if (next) next.disabled = track.scrollLeft >= max - 1;
        };
        if (track) {
          track.addEventListener('scroll', update, { passive: true });
          window.addEventListener('resize', update);
          update();
        }
        const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: this.reduceMotion ? 'auto' : 'smooth' });
        if (prev) prev.addEventListener('click', () => step(-1));
        if (next) next.addEventListener('click', () => step(1));

      }

      async quickAdd(btn) {
        const id = Number(btn.dataset.variantId);
        if (!Number.isInteger(id) || id <= 0 || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        btn.disabled = true;
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        try {
          const cartType = this.dataset.cartType || 'cart-drawer';
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id, quantity: 1 }],
              sections: HELPER_UTIL.sectionRenderUtil(cartType).getSectionsString(),
              sections_url: root + 'variants/' + id
            })
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok) throw new Error(data && data.description ? String(data.description) : 'add_failed');

          if (this.dataset.afterAdd === 'cart_page' && this.dataset.cartUrl) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }

          const cartDrawer = document.querySelector('drawer-cart');
          const showCartPopup = this.hasAttribute('show-cart-popup');
          window.currentActiveElement = btn;
          if (cartDrawer) {
            HELPER_UTIL.dispatchCustomEvent(
              showCartPopup ? _EVENT_HELPER.showCartPopup : _EVENT_HELPER.triggerCartChange,
              btn,
              { sections: data.sections }
            );
          } else if (showCartPopup) {
            const cartBubble = HELPER_UTIL.getHTMLFromString(data.sections['cart-count-bubble'], '[header-cart-bubble]');
            if (cartBubble) {
              document.querySelectorAll('[header-cart-bubble]').forEach((bubble) => {
                bubble.innerHTML = cartBubble.innerHTML;
              });
            }
            HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.showCartPopup, btn, { sections: data.sections });
          } else {
            window.location.assign(this.dataset.cartUrl || root + 'cart');
            return;
          }

          let cart = null;
          try { cart = await (await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })).json(); } catch (e) {}
          const detail = { variantId: id, cart, items: data && data.items };
          document.dispatchEvent(new CustomEvent('rising-brand:cart-added', { detail }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail }));

          btn.classList.add('is-added');
          this.say('장바구니에 담았습니다.');
          setTimeout(() => btn.classList.remove('is-added'), 1600);
        } catch (err) {
          const msg = err && err.message && err.message !== 'add_failed' ? err.message : '장바구니에 담지 못했습니다. 다시 시도해 주세요.';
          this.say(msg);
        } finally {
          btn.disabled = false;
        }
      }

      say(msg) { if (this.live) this.live.textContent = msg; }
    }
    customElements.define('rising-brand', RisingBrand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cj-collection-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cj-collection-tabs')) {
  customElements.define('cj-collection-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      this.listeners = new AbortController();
      const options = {signal: this.listeners.signal};
      this.tabs = [...this.querySelectorAll('[role=tab]')];
      this.status = this.querySelector('[role=status]');
      this.querySelector('[role=tablist]').addEventListener('click', event => {
        const tab = event.target.closest('[role=tab]');
        if (!tab || tab.getAttribute('aria-selected') === 'true') return;
        const url = new URL(tab.dataset.url, location.origin);
        this.contextParams(url);
        this.load(url, 'push', tab);
      }, options);
      this.addEventListener('keydown', event => {
        const current = event.target.closest('[role=tab]');
        if (!current) return;
        let index = this.tabs.indexOf(current);
        if (event.key === 'ArrowRight') index = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') index = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.tabs[index].focus();
      }, options);
      document.addEventListener('click', event => {
        const link = event.target.closest('#collection-grid .pagination a');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        const url = new URL(link.href);
        this.contextParams(url);
        this.load(url, 'push');
      }, options);
      window.addEventListener('popstate', () => {
        if (location.pathname + location.search === this.currentUrl) return;
        this.load(new URL(location.href), 'none');
      }, options);
      this.currentUrl = location.pathname + location.search;
      this.bindPanel();
    }
    contextParams(url) {
      url.searchParams.set('view', this.dataset.view);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
    }
    bindPanel() {
      const grid = document.querySelector('#collection-grid');
      if (!grid) return;
      document.querySelectorAll('#filter-drawer-form input[type=number]').forEach(input => { input.step = 'any'; });
      const panel = grid;
      panel.setAttribute('role', 'tabpanel');
      const selected = this.tabs.find(tab => tab.dataset.url === this.dataset.currentPath) || this.tabs[0];
      this.tabs.forEach(tab => {
        tab.setAttribute('aria-selected', String(tab === selected));
        tab.tabIndex = tab === selected ? 0 : -1;
      });
      panel.setAttribute('aria-labelledby', selected.id);
      grid.querySelectorAll('.pagination a').forEach(link => {
        const url = new URL(link.href);
        this.contextParams(url);
        link.href = url.href;
      });
    }
    renderFilters(searchParams, updateHistory = true) {
      const url = new URL(location.pathname, location.origin);
      url.search = searchParams;
      this.contextParams(url);
      return this.load(url, updateHistory ? 'push' : 'none');
    }
    async load(url, historyMode, tab) {
      this.request?.abort();
      this.request = new AbortController();
      const request = this.request;
      const grid = document.querySelector('#collection-grid');
      if (!grid) return;
      grid.setAttribute('aria-busy', 'true');
      this.status.classList.add('visually-hidden');
      this.status.textContent = this.dataset.loading;
      try {
        const sectionUrl = new URL(url);
        sectionUrl.searchParams.set('section_id', grid.dataset.id);
        const response = await fetch(sectionUrl, {signal: request.signal});
        if (!response.ok) throw new Error('Collection request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = doc.querySelector('#collection-grid');
        if (!nextGrid) throw new Error('Collection content missing');
        if (request.signal.aborted) return;
        grid.innerHTML = nextGrid.innerHTML;
        grid.setAttribute('aria-label', nextGrid.getAttribute('aria-label') || '');
        const drawer = document.querySelector('filter-component.filter-drawer [filter-options]');
        const nextDrawer = doc.querySelector('filter-component.filter-drawer [filter-options]');
        if (drawer && nextDrawer) drawer.innerHTML = nextDrawer.innerHTML;
        this.dataset.currentPath = url.pathname;
        const searchParams = url.search.slice(1);
        if (historyMode === 'push') history.pushState({searchParams}, '', url);
        this.currentUrl = url.pathname + url.search;
        document.dispatchEvent(new CustomEvent('cj:collection-change', {detail:{url:url.pathname}}));
        if (typeof FilterForm !== 'undefined') {
          FilterForm.searchParamsPrev = searchParams;
          FilterForm.filterData = [];
        }
        if (typeof CollectionUtil !== 'undefined') CollectionUtil.initEvents();
        grid.querySelectorAll('default-player').forEach(video => video._renderMedia?.());
        this.bindPanel();
        this.status.textContent = '';
        if (tab) tab.scrollIntoView({block:'nearest', inline:'nearest', behavior:'instant'});
        const filterDrawer = document.querySelector('filter-component.filter-drawer');
        if (filterDrawer && typeof HELPER_UTIL !== 'undefined' && typeof _EVENT_HELPER !== 'undefined') {
          HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.hideDrawer, document, {drawerType:'filter'});
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.status.classList.remove('visually-hidden');
          this.status.textContent = this.dataset.error;
        }
      } finally {
        if (this.request === request) grid.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() {
      this.listeners?.abort();
      this.request?.abort();
      this.listeners = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cj-coupon-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cj-coupon-banner')) {
    customElements.define('cj-coupon-banner', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.querySelectorAll('[data-copy-code]').forEach(button => { button.disabled = false; });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-copy-code]');
          if (button && this.contains(button)) this.copy(button, event);
          if (event.target.closest('[data-dismiss]')) this.querySelector('.cj-coupon__manual').hidden = true;
        }, { signal: this.events.signal });
        const input = this.querySelector('.cj-coupon__manual input');
        input.addEventListener('click', () => input.select(), { signal: this.events.signal });
        window.addEventListener('pointermove', event => {
          if (!this.feedbackPoint?.followCursor || event.pointerType === 'touch') return;
          this.feedbackPoint.x = event.clientX;
          this.feedbackPoint.y = event.clientY;
          this.positionFeedback();
        }, { signal: this.events.signal, passive: true });
        window.addEventListener('scroll', () => this.hideFeedback(), { signal: this.events.signal, capture: true, passive: true });
        window.addEventListener('resize', () => this.hideFeedback(), { signal: this.events.signal, passive: true });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') this.hideFeedback();
        }, { signal: this.events.signal });
      }
      positionFeedback() {
        const status = this.querySelector('.cj-coupon__status');
        const point = this.feedbackPoint;
        if (!point || status.hidden) return;
        const edge = 8;
        const gap = 12;
        const box = status.getBoundingClientRect();
        const width = document.documentElement.clientWidth;
        const height = window.innerHeight;
        let left = point.followCursor ? point.x + gap : point.x - box.width / 2;
        let top = point.y + gap;
        if (point.followCursor && left + box.width > width - edge) left = point.x - box.width - gap;
        if (top + box.height > height - edge) top = (point.above ?? point.y) - box.height - gap;
        status.style.left = `${Math.max(edge, Math.min(left, width - box.width - edge))}px`;
        status.style.top = `${Math.max(edge, Math.min(top, height - box.height - edge))}px`;
      }
      hideFeedback() {
        clearTimeout(this.timer);
        this.feedbackPoint = null;
        const status = this.querySelector('.cj-coupon__status');
        status.hidden = true;
        status.textContent = '';
      }
      async copy(button, event) {
        const code = button.dataset.copyCode;
        if (!code || button.disabled) return;
        button.disabled = true;
        this.hideFeedback();
        const followCursor = event.detail > 0 && event.pointerType !== 'touch' && window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;
        const rect = button.getBoundingClientRect();
        this.feedbackPoint = followCursor
          ? { x: event.clientX, y: event.clientY, followCursor: true }
          : { x: rect.left + rect.width / 2, y: rect.bottom, above: rect.top, followCursor: false };
        this.querySelector('.cj-coupon__manual').hidden = true;
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(code);
          if (!this.isConnected || !this.feedbackPoint) return;
          const status = this.querySelector('.cj-coupon__status');
          status.textContent = this.dataset.success;
          status.hidden = false;
          this.positionFeedback();
          this.timer = setTimeout(() => this.hideFeedback(), 2500);
        } catch {
          if (!this.isConnected) return;
          this.hideFeedback();
          const manual = this.querySelector('.cj-coupon__manual');
          const input = manual.querySelector('input');
          input.value = code;
          manual.hidden = false;
          input.focus();
          input.select();
        } finally {
          button.disabled = false;
        }
      }
      disconnectedCallback() {
        this.hideFeedback();
        this.events?.abort();
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cj-event-bestsellers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cj-event-bestsellers')) {
  customElements.define('cj-event-bestsellers', class extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      this.listeners = new AbortController();
      const options = {signal:this.listeners.signal};
      this.rail = this.querySelector('.cj-bestsellers__rail');
      this.status = this.querySelector('[role=status]');
      this.cache = new Map();
      this.cacheLifetime = 5 * 60 * 1000;
      this.loading = false;
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.refreshIfStale();
      }, options);
      window.addEventListener('pageshow', () => this.refreshIfStale(), options);
      window.addEventListener('focus', () => this.refreshIfStale(), options);
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.rail.scrollBy({left:Number(button.dataset.direction) * this.cardStep(), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, options));
      this.rail.addEventListener('scroll', () => this.updateControls(), options);
      this.resize = new ResizeObserver(() => this.updateControls());
      this.resize.observe(this.rail);
      this.querySelector('[data-retry]').addEventListener('click', () => this.load(this.dataset.collection), options);
      document.addEventListener('cj:collection-change', event => {
        if (event.detail.url !== this.dataset.collection) this.load(event.detail.url);
      }, options);
      if (this.dataset.initialBestsellers === 'true') {
        this.cache.set(this.dataset.collection, {html:this.rail.innerHTML, time:Date.now()});
        this.updateControls();
        this.scheduleRefresh();
      } else this.load(this.dataset.collection);
    }
    scheduleRefresh() {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => this.refreshIfStale(), this.cacheLifetime);
    }
    refreshIfStale() {
      const cached = this.cache.get(this.dataset.collection);
      if (!this.loading && !document.hidden && (!cached || Date.now() - cached.time >= this.cacheLifetime)) this.load(this.dataset.collection, true);
    }
    cardStep() {
      const card = this.rail.querySelector('.cj-bestsellers__card');
      return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap || 0) : this.rail.clientWidth;
    }
    updateControls() {
      const position = this.rail.scrollLeft;
      const maximum = this.rail.scrollWidth - this.rail.clientWidth;
      const loading = this.rail.getAttribute('aria-busy') === 'true';
      const previous = this.querySelector('[data-direction="-1"]');
      const next = this.querySelector('[data-direction="1"]');
      previous.disabled = loading || position <= 2;
      next.disabled = loading || position >= maximum - 2;
      [previous, next].forEach(button => button.classList.toggle('swiper-button-disabled', button.disabled));
      const steps = Math.ceil(maximum / Math.max(1, this.cardStep())) + 1;
      const progress = maximum > 0 ? (1 + Math.max(0, position) / maximum * (steps - 1)) / steps : 1;
      this.querySelector('.swiper-pagination-progressbar-fill').style.transform = `scaleX(${Math.min(1, progress)})`;
      this.querySelector('.cj-bestsellers__controls').hidden = loading || maximum <= 2;
    }
    async load(path, background = false) {
      this.request?.abort();
      this.request = new AbortController();
      const request = this.request;
      clearTimeout(this.refreshTimer);
      this.loading = true;
      this.status.classList.add('visually-hidden');
      this.status.textContent = '';
      this.dataset.collection = path;
      const scrollPosition = background ? this.rail.scrollLeft : 0;
      if (!background) {
        this.rail.innerHTML = '<div class="cj-bestsellers__card cj-bestsellers__skeleton" aria-hidden="true"></div>'.repeat(3);
        this.status.textContent = this.dataset.loading;
      }
      this.rail.setAttribute('aria-busy', 'true');
      this.querySelector('[data-retry]').hidden = true;
      this.updateControls();
      try {
        const cached = this.cache.get(path);
        let html = cached && Date.now() - cached.time < this.cacheLifetime ? cached.html : undefined;
        if (html === undefined) {
          const url = new URL(path, location.origin);
          url.search = '';
          url.searchParams.set('view', this.dataset.view);
          url.searchParams.set('section_id', this.dataset.section);
          url.searchParams.set('sort_by', 'best-selling');
          const preview = new URLSearchParams(location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, {signal:request.signal, cache:'no-cache'});
          if (!response.ok) throw new Error('Products unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = doc.querySelector('cj-event-bestsellers [data-products]');
          if (!content) throw new Error('Products missing');
          if (request.signal.aborted) return;
          html = content.innerHTML;
          this.cache.set(path, {html, time:Date.now()});
        }
        if (request.signal.aborted) return;
        if (!background || !cached || cached.html !== html) this.rail.innerHTML = html;
        this.rail.scrollLeft = scrollPosition;
        this.status.textContent = '';
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.rail.querySelectorAll('.cj-bestsellers__skeleton').forEach(card => card.remove());
          this.status.classList.remove('visually-hidden');
          this.status.textContent = this.dataset.error;
          this.querySelector('[data-retry]').hidden = false;
        }
      } finally {
        if (this.request === request) {
          this.loading = false;
          this.scheduleRefresh();
          this.rail.setAttribute('aria-busy', 'false');
          this.updateControls();
        }
      }
    }
    disconnectedCallback() {
      clearTimeout(this.refreshTimer);
      this.request?.abort();
      this.request = null;
      this.listeners?.abort();
      this.resize?.disconnect();
      this.listeners = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-events"]) return;
  try {
    
  if (!customElements.get('cj-events')) {
    customElements.define('cj-events', class extends HTMLElement {
      connectedCallback() {
        this.updateEventStates = () => {
          const now = Date.now();
          let nextUpdate = 2147483647;
          const list = this.querySelector('.ev-list');
          const cards = Array.from(list.querySelectorAll('.ev-card'));
          const statusOrder = { ongoing: 0, upcoming: 1, ended: 2 };
          const statusLabels = {
            ongoing: this.dataset.ongoingLabel,
            upcoming: this.dataset.upcomingLabel,
            ended: this.dataset.endedLabel,
          };
          cards.forEach((card) => {
            const start = Date.parse(`${card.dataset.startDate}T00:00:00${this.dataset.timezoneOffset}`);
            const end = Date.parse(`${card.dataset.endDate}T23:59:59.999${this.dataset.timezoneOffset}`);
            let status = 'ongoing';
            if (Number.isFinite(end) && now > end) {
              status = 'ended';
            } else if (Number.isFinite(start) && now < start) {
              status = 'upcoming';
            }

            card.dataset.status = status;
            card.querySelector('.ev-badge').textContent = statusLabels[status];
            const link = card.querySelector('a.ev-card-content');
            if (link) {
              if (status === 'ended') {
                link.removeAttribute('href');
                link.setAttribute('aria-disabled', 'true');
                link.setAttribute('tabindex', '-1');
              } else {
                link.setAttribute('href', link.dataset.eventLink);
                link.removeAttribute('aria-disabled');
                link.removeAttribute('tabindex');
              }
            }
            if (status === 'upcoming') nextUpdate = Math.min(nextUpdate, start - now);
            if (status !== 'ended' && Number.isFinite(end)) nextUpdate = Math.min(nextUpdate, end - now + 1);
          });
          const sortedCards = [...cards].sort((first, second) => {
            const statusDifference = statusOrder[first.dataset.status] - statusOrder[second.dataset.status];
            if (statusDifference) return statusDifference;
            const firstDate = first.dataset.startDate || '0000-01-01';
            const secondDate = second.dataset.startDate || '0000-01-01';
            const dateDifference = secondDate.localeCompare(firstDate);
            if (dateDifference) return dateDifference;
            const firstOrder = Number(first.dataset.duplicateOrder || Number.MAX_SAFE_INTEGER);
            const secondOrder = Number(second.dataset.duplicateOrder || Number.MAX_SAFE_INTEGER);
            return firstOrder - secondOrder;
          });
          if (sortedCards.some((card, index) => card !== cards[index])) list.append(...sortedCards);
          this.timer = window.setTimeout(this.updateEventStates, nextUpdate);
        };
        this.updateEventStates();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('cj-pdp-divider-alignment')) {
    customElements.define('cj-pdp-divider-alignment', class extends HTMLElement {
      connectedCallback() {
        this.productRoot = this.closest('.main-product--cj-figma');
        if (!this.productRoot) return;
        this.offsets = new Map();
        this.frame = 0;
        this.schedule = () => {
          if (this.frame || !this.isConnected) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.alignDividers();
          });
        };
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this.productRoot);
        this.observer.observe(document.body);
        const details = this.productRoot.querySelector('.main-product__details');
        if (details) this.observer.observe(details);
        window.addEventListener('resize', this.schedule);
        window.addEventListener('scroll', this.schedule, { passive: true });
        this.productRoot.addEventListener('click', this.schedule);
        document.fonts?.addEventListener('loadingdone', this.schedule);
        document.fonts?.ready.then(this.schedule);
        this.schedule();
      }

      resetDividers() {
        this.offsets?.forEach((offset, divider) => {
          divider.style.removeProperty('--cj-divider-offset');
          divider.removeAttribute('data-cj-divider-aligned');
        });
        this.offsets?.clear();
      }

      alignDividers() {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          this.resetDividers();
          return;
        }
        const ratio = window.devicePixelRatio || 1;
        const dividers = this.productRoot.querySelectorAll(
          '[class*="ai-collapsible-divider-"], [class*="ai-how-to-use-divider-"]'
        );
        const updates = Array.from(dividers, divider => {
          const rect = divider.getBoundingClientRect();
          if (!rect.height) return null;
          const previous = this.offsets.get(divider) || 0;
          const top = rect.top + window.scrollY - previous;
          const offset = Math.round((Math.round(top * ratio) / ratio - top) * 1000000) / 1000000;
          return { divider, previous, offset };
        });
        updates.forEach(update => {
          if (!update) return;
          const { divider, previous, offset } = update;
          if (this.offsets.has(divider) && Math.abs(previous - offset) < 0.0001) return;
          divider.style.setProperty('--cj-divider-offset', `${offset}px`);
          divider.setAttribute('data-cj-divider-aligned', '');
          this.offsets.set(divider, offset);
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        window.removeEventListener('resize', this.schedule);
        window.removeEventListener('scroll', this.schedule);
        this.productRoot?.removeEventListener('click', this.schedule);
        document.fonts?.removeEventListener('loadingdone', this.schedule);
        this.resetDividers();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
